module.exports = __webpack_public_path__ + "img/setting.0e3afdc3.png";